import React, { useRef } from 'react';
import cn from 'classnames';

import Form, { hiddenForm } from './Form';
import { useClickAway, useKey } from 'react-use';

import CloseIcon from '../../images/icons/close.svg';

import { GOALS, trackGoal } from '../../utils/fathom';

import * as styles from './ContactForm.module.css';

export default function ContactForm({ onCloseIntent, shown }) {
  const ref = useRef(null);

  const closeContactForm = () => {
    if (!shown) return;
    trackGoal(GOALS.CLOSE_CONTACT_FORM);
    onCloseIntent();
  };

  useClickAway(ref, closeContactForm);
  useKey('Escape', closeContactForm);

  return (
    <div className={cn(styles.root)}>
      {hiddenForm}
      <div ref={ref}>
        <Form />
        <button className={styles.closeButton} onClick={closeContactForm}>
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}
